/****************************************************
 * Module Name:  StoneJourneyProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class StoneJourneyProxy {

    static GetAllMediaBuilderData = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/stonejourney",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddKapanPacketData = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/stonejourney`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UploadProcessImages = (data, kapanid, packetid, processid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/stonejourney/image/${kapanid}/${packetid}/${processid}`,
            "post",
            Constants.userToken,
            undefined,
            data,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UploadProcessVideos = (data, kapanid, packetid, processid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/stonejourney/video/${kapanid}/${packetid}/${processid}`,
            "post",
            Constants.userToken,
            undefined,
            data,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static CreateVideo = (kapanid, packetid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/stonejourney/create/video/${kapanid}/${packetid}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => {
                callback(response);
            })
            .catch((error) => {
                callback(undefined);
            });
    };

    static createPdf = (kapanid, packetid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/stonejourney/create/pdf/${kapanid}/${packetid}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => {
                callback(response);
            })
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetMergedVideo = (kapanid, packetid, callback) => {
        const url = Constants.MANAGER_URL + `/stonejourney/video/${kapanid}/${packetid}`;

        fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${Constants.userToken}`
            }
        })
            .then(response => response.blob())
            .then(blob => {
                if (callback) {
                    callback(blob);
                }
            })
            .catch(error => {
                console.error("Error downloading video:", error);
                callback(undefined);
            });
    };

    static GetMergedPdf = (kapanid, packetid, callback) => {
        const url = Constants.MANAGER_URL + `/stonejourney/pdf/${kapanid}/${packetid}`;

        fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${Constants.userToken}`
            }
        })
            .then(response => response.blob())
            .then(blob => {
                if (callback) {
                    callback(blob);
                }
            })
            .catch(error => {
                console.error("Error downloading video:", error);
                callback(undefined);
            });
    };

    static DeleteStoneJourney = (data, callback) => {

        restAPICall(
            Constants.MANAGER_URL + `/stonejourney`,
            "delete",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
};